export const UPDATE_MUT = 'UPDATE_MUT'
export const DELETE_MUT = 'DELETE_MUT'
export const ADD_MUT = 'ADD_MUT'
export const SET_MUT = 'SET_MUT'
export const SET_ONE_MUT = 'SET_ONE_MUT'
